import { SHOW_BANNER } from './actionType'

export const initialState = {
  isShown: false,
  message: '',
}

export default function bannerReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_BANNER: {
      const { payload } = action
      const { isShown, message } = payload
      const newState = {
        ...state,
        isShown,
        message,
      }
      return newState
    }
    default:
      return state
  }
}
